import React from 'react'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// styles
import styles from './index.module.scss'
import Artist from 'assets/images/dashboard-avatar.png'
import Link from 'next/link'
import { getDisplayUserName } from 'utils/strings'

const TrendingCreatorCard = props => {
  const { artist } = props

  return (
    <Link href={`${window.origin}/${artist.username}`} passHref>
      <a className="w-full h-full">
        <div className={styles.container}>
          <div className={styles.imageArea}>
            <ImageWithFoster
              src={
                artist.profile_picture !== null && artist.profile_picture !== undefined && artist.profile_picture !== ''
                  ? artist.profile_picture
                  : Artist.src
              }
              className="w-full h-full max-w-full max-h-full object-contain rounded-full"
            />
          </div>
          <div className="w-full flex justify-center">
            <div className={styles.name}>{getDisplayUserName(artist.username)}</div>
          </div>
        </div>
      </a>
    </Link>
  )
}

export default TrendingCreatorCard
